import React from "react";
import {useCallback, useEffect, useState} from "react"

// --- Hooks ---
import { useTiptapEditor } from "hooks/use-tiptap-editor"

// --- Icons ---
import { ChevronDownIcon } from "components/tiptap-icons/chevron-down-icon"

// --- Tiptap UI ---
import { ListButton } from "components/tiptap-ui/list-button";

import { useListDropdownMenu } from "components/tiptap-ui/list-dropdown-menu/use-list-dropdown-menu"

import { Button, ButtonGroup } from "components/tiptap-ui-primitive/button"
import {
    DropdownMenu,
    DropdownMenuTrigger,
    DropdownMenuContent,
    DropdownMenuItem,
} from "components/tiptap-ui-primitive/dropdown-menu"
import { Card, CardBody } from "components/tiptap-ui-primitive/card"
import {TextAlignButton, textAlignIcons} from "../text-align-button";
import {ToolbarGroup} from "../../tiptap-ui-primitive/toolbar";

export function CollapsableToolbarGroup({
                                         editor: providedEditor,
                                         onOpenChange,
                                         collapsedMaxWidth,
                                         portal = false, 
                                         Icon,
                                         children,
                                         ...props
     }) {
    const [isOpen, setIsOpen] = useState(false)
    const [isCollapsed, setIsCollapsed] = useState(false)

    useEffect(() => {
        const handleResize = () => {
            setIsCollapsed(window.innerWidth < collapsedMaxWidth);
        };

        handleResize(); // initial check
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleOnOpenChange = useCallback((open) => {
        setIsOpen(open)
        onOpenChange?.(open)
    }, [onOpenChange])
    
    return (
        <ToolbarGroup>
            {isCollapsed ? (
                <DropdownMenu open={isOpen} onOpenChange={handleOnOpenChange}>
                    <DropdownMenuTrigger asChild>
                        <Button
                            type="button"
                            data-style="ghost"
                            role="button"
                            tabIndex={-1}
                            aria-label="Align options"
                            tooltip="Align"
                            {...props}>
                            <Icon className="tiptap-button-icon" />
                            <ChevronDownIcon className="tiptap-button-dropdown-small" />
                        </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="start" portal={portal}>
                        <Card>
                            <CardBody>
                                <ButtonGroup>
                                  {React.Children.map(children, (child) => (
                                    <DropdownMenuItem asChild>{child}</DropdownMenuItem>
                                  ))}
                                </ButtonGroup>
                            </CardBody>
                        </Card>
                    </DropdownMenuContent>
                </DropdownMenu>
            ) : (
                <> 
                    {children}
                </>
            )}
        </ToolbarGroup>
    );
}

export default CollapsableToolbarGroup
